import { render, staticRenderFns } from "./SettingsMail.vue?vue&type=template&id=35fbcb55&scoped=true"
import script from "./SettingsMail.vue?vue&type=script&lang=js"
export * from "./SettingsMail.vue?vue&type=script&lang=js"
import style0 from "./SettingsMail.vue?vue&type=style&index=0&id=35fbcb55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbcb55",
  null
  
)

export default component.exports